import type { BookingPaymentSource } from '../../types/api/v2/obt/model/booking-payment-source';
import { PaymentSourceType } from '../../types/api/v2/obt/model/payment-source-type';

interface IGetPaymentSourcerewardsProgramInfo {
  id: string | undefined;
  isUsable: boolean | undefined;
  points: number;
}

export const getPaymentSourceRewardsProgramInfo = (
  paymentSource: BookingPaymentSource | undefined,
): IGetPaymentSourcerewardsProgramInfo => {
  let points = 0;
  if (
    paymentSource?.type === PaymentSourceType.RewardsProgram &&
    paymentSource?.metadata &&
    'rewardsProgramMetadata' in paymentSource?.metadata
  ) {
    const metadata = paymentSource.metadata.rewardsProgramMetadata;
    points = metadata.pointsBalance?.amount || 0;
  }

  return { id: paymentSource?.id, isUsable: paymentSource?.isUsable, points };
};
